module.exports = __webpack_public_path__ + "img/rain.921778f0.svg";